import { useMemo } from 'react';

import { ProjectInvoiceControl } from 'entities';

import { Column } from 'components/Blocks';

import { InvoiceWrapper } from '../Wrapper';

import { PaymentInfo } from './PaymentInfo';
import { Standard } from './Standard';
import { Package } from './Package';
import { OutsourceInvoices } from './OutsourceInvoices';
import { InvoiceAlerts } from './Alerts';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';

type InvoiceType = Exclude<ProjectInvoiceControl['type'], undefined>;

const typeComponents: Record<InvoiceType, typeof Package> = {
  STANDARD: Standard,

  PACKAGE: Package,
};

export function ReadyToInvoice() {
  const {
    project: { invoice },
  } = useProjectProfile();

  const TypeComponent = useMemo(
    () => (invoice.type ? typeComponents[invoice.type as InvoiceType] : () => null),
    [invoice],
  );

  return (
    <InvoiceWrapper>
      <Column gap="6">
        <InvoiceAlerts />

        <PaymentInfo />

        <TypeComponent />

        <OutsourceInvoices />
      </Column>
    </InvoiceWrapper>
  );
}
